module.exports = "fragment DetailedLayoutFragment on Layout {\n  ...LayoutFragment\n  panel {\n    ...PanelFragment\n  }\n}\n"